$(document).ready(function () {
	$("#navigations >button, .button--domluvit_prohlidku").each(function () {
		$(this).on("click", function (event) {
			event.preventDefault();
			var toggleClass = $(this).attr("toggleClass");
			$("#navigations >button").each(function () {
				var clearClass = $(this).attr("toggleClass");
				if (clearClass != toggleClass) {
					$("#navigations").removeClass(clearClass);
					$("body").removeClass("body_" + clearClass);
				}
			});

			$("#navigations").toggleClass(toggleClass);
			$("body").toggleClass("body_" + toggleClass);
			return false;
		});
	});

	$("body > *").not("#navigations, #navigations > *").on("click", function () {
		// console.log(this);
		$("#navigations").removeClass("menu-opened domluvit-prohlidku-opened cart-opened")
		$("body").removeClass("body_menu-opened body_domluvit-prohlidku-opened body_cart-opened")
	});

	$("#domluvit_prohlidku--tabs").easytabs({
		animate: false,
		collapsedByDefault: false,
		defaultTab: "li:first-child",
		updateHash: false
	});

	$("#domluvit_prohlidku-pujcit .contact-box a").click(function (event) {
		event.preventDefault()
		$("#domluvit_prohlidku--tabs").easytabs('select', '#domluvit_prohlidku-phone');
	})
});
